import axios from "axios";
import { create } from "zustand";

export const API_SLUG = "/queue";

export interface QueueStore {
  searchPatient: any[];
  setSearchPatient: (searchPatient: any) => void;
  getSearchPatient: (
    secret: string,
    data: any
  ) => Promise<{ success: boolean; data: any; httpStatus: number }>;
  assignPatientToQueue: (
    secret: string,
    data: any
  ) => Promise<{ success: boolean; data: any; httpStatus: number }>;
  clearState: () => void;
}

export const useQueueStore = create<QueueStore>((set) => ({
  searchPatient: [],
  setSearchPatient: (searchPatient) => set({ searchPatient }),
  getSearchPatient: async (secret, input) => {
    const formData = new FormData();
    Object.keys(input).forEach((key) => {
      formData.append(key, input[key]);
    });

    return axios
      .post(`${API_SLUG}/search-patient`, formData, {
        headers: {
          Authorization: `Bearer ${secret}`,
        },
      })
      .then((res) => {
        set({ searchPatient: res.data });
        return { success: true, data: res.data, httpStatus: 200 };
      })
      .catch((err) => {
        return {
          success: false,
          data:
            err.response.data?.message?.toString() ?? "Something went wrong",
          httpStatus: err.response.status,
        };
      });
  },
  assignPatientToQueue: async (secret, input) => {
    const formData = new FormData();
    Object.keys(input).forEach((key) => {
      formData.append(key, input[key]);
    });

    return axios
      .post(`${API_SLUG}/assign-patient`, formData, {
        headers: {
          Authorization: `Bearer ${secret}`,
        },
      })
      .then((res) => {
        return { success: true, data: res.data, httpStatus: 200 };
      })
      .catch((err) => {
        return {
          success: false,
          data:
            err.response.data?.message?.toString() ?? "Something went wrong",
          httpStatus: err.response.status,
        };
      });
  },
  clearState: () => {
    set({ searchPatient: [] });
  },
}));
